/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deletePin.defs.js";
export { main as default } from "./deletePin.defs.js";
